import { render, staticRenderFns } from "./wxShare_contentDetail.vue?vue&type=template&id=cdf005de&scoped=true&"
import script from "./wxShare_contentDetail.vue?vue&type=script&lang=js&"
export * from "./wxShare_contentDetail.vue?vue&type=script&lang=js&"
import style0 from "./wxShare_contentDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./wxShare_contentDetail.vue?vue&type=style&index=1&id=cdf005de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf005de",
  null
  
)

export default component.exports